import React from 'react';
import {Col, Panel, Row} from 'react-bootstrap';
import PropTypes from 'prop-types';
import Button from './token-filter-button';

const TokenFilter = ({
  onChange, onClear, onSearch, doSearch, searchValue = ''
}) => (
  <Row>
    <Col md={12}>
      <Panel className="mg-tb-20">
        <Row>
          <Col lg={9} style={{paddingRight: 0}}>
            <div className="fluid">
              <input
                className="form-control"
                onChange={onChange}
                onKeyPress={doSearch}
                placeholder="First name / Last name / Email"
                value={searchValue}
              />
            </div>
          </Col>
          <Col lg={3} style={{paddingLeft: 0}}>
            <div className="fluid text-right">
              <Button label="Search" action={onSearch}/>
              <Button label="Reset" action={onClear}/>
            </div>
          </Col>
        </Row>
      </Panel>
    </Col>
  </Row>
);

TokenFilter.propTypes = {
  searchValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default TokenFilter;



// WEBPACK FOOTER //
// ./src/components/admin/app/user-access-tokens/token-filter.jsx